import { render } from "./ScheduleRadiologyTab.vue?vue&type=template&id=0fc3aa74"
import script from "./ScheduleRadiologyTab.vue?vue&type=script&lang=js"
export * from "./ScheduleRadiologyTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__